import { call, put, take } from 'redux-saga/effects'
import api from '../api/api'
import coursesSchema from '../schemas/courses'
import eventsSchema from '../schemas/events'
import testSchema from '../schemas/test'
import { normalize } from 'normalizr'

import {
  FETCH_FEATURED_ITEMS_REQUEST,
  FETCH_FEATURED_ITEMS_FAIL,
  FETCH_FEATURED_ITEMS_ASYNC_START,
  FETCH_FEATURED_ITEMS_ASYNC_END,
  FETCH_COURSES_LIST_SUCCESS,
  FETCH_EVENTS_SUCCESS,
  FETCH_ONLINE_TESTS_SUCCESS,
} from '../actions/actions.js'

const successActionsToDispatch = [
  FETCH_COURSES_LIST_SUCCESS,
  FETCH_EVENTS_SUCCESS,
  FETCH_ONLINE_TESTS_SUCCESS,
]
const schemas = [coursesSchema, eventsSchema, testSchema]
const titles = ['courses', 'events', 'tests']

export function* getFeaturedItems() {
  while (true) {
    const { resolve, reject } = yield take(FETCH_FEATURED_ITEMS_REQUEST)
    yield put({ type: FETCH_FEATURED_ITEMS_ASYNC_START })

    try {
      const [
        {
          data: {
            data: { courses: featuredCourses },
          },
        },
        {
          data: {
            data: { events: featuredEvents },
          },
        },
        // {
        //   data: {
        //     data: { quizs: /* i know! */ featuredTests },
        //   },
        // },
      ] = yield call(api.getFeaturedItems)

      const data = [featuredCourses, featuredEvents,] //featuredTests]
      resolve && resolve(data)

      for (let index = 0; index < successActionsToDispatch.length; index++) {
        yield put({
          type: successActionsToDispatch[index],
          [titles[index]]: normalize(data[index], schemas[index]),
        })
      }

      yield put({ type: FETCH_FEATURED_ITEMS_ASYNC_END })
    } catch (error) {
      reject && reject()
      yield put({ type: FETCH_FEATURED_ITEMS_FAIL, error })
      yield put({ type: FETCH_FEATURED_ITEMS_ASYNC_END })
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/featuredSaga.js